import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Plan from "./Plan";
import plansSocialClub from "../../data/home_borin/plansSocialClub.json";
import ImgSlider from "./ImgSlider";
import socialAreasSocialClub from "../../data/home_borin/socialAreasSocialClub.json";

function SocialClub() {
  const firstGroup = ["Boliche", "Palco", "Bar", "Sinuca"];
  const secondGroup = ["Poker", "Airsoft", "Área externa"];

  const [imageSrc, setImageSrc] = useState(
    "/home_borin/assets/images/socialClub/socialClub.webp"
  );

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth < 1024) {
        setImageSrc(
          "/home_borin/assets/images/socialClub/socialClub-mobile.webp"
        );
      } else {
        setImageSrc("/home_borin/assets/images/socialClub/socialClub.webp");
      }
    };

    // Chama a função na montagem do componente
    updateImage();

    // Adiciona o event listener para atualizar a imagem ao redimensionar
    window.addEventListener("resize", updateImage);

    // Remove o event listener ao desmontar o componente
    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <>
      <section id="id_socialClub" className="header-social-club">
        <div className="container">
          <div className="content bg-white">
            <div className="col-lg-12">
              <div className="image-wrapper wow zoomIn slow">
                <LazyLoadImage
                  src={imageSrc}
                  alt="hall do health"
                  effect="Imagem do social club"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
            </div>
            <div className="col-lg-11 d-flex justify-self-end bg-white flex-wrap">
              <div className="col-lg-6 legacy p-100">
                <div className="d-flex icon-title">
                  <div className="logo text-center d-inline-block me-20 img wow zoomIn slow align-content-center">
                    <img
                      src="/home_borin/assets/images/logo.svg"
                      alt="logo da Wiser"
                    />
                  </div>
                  <h2 className="js-splittext-lines color-gray">
                    <span className="fsz-60 color-brown1 text-uppercase font-palast-regular ltspc-10 title-social-club">
                      Social Club
                    </span>
                  </h2>
                </div>
                <p
                  className="fsz-16 color-gray mt-30 wow zoomIn slow ltspc-2 lh-1"
                  data-wow-delay="0.2s"
                >
                  Onde os encontros se transformam em momentos inesquecíveis. O
                  Social Club do Wiser foi pensado para conectar pessoas e
                  celebrar a vida com estilo e sofisticação.
                </p>
                <p
                  className="fsz-16 color-gray mt-20 wow zoomIn slow ltspc-2 lh-1"
                  data-wow-delay="0.2s"
                >
                  Com acesso tanto para o Legacy Residence quanto Legacy Health,
                  este espaço oferece um ambiente vibrante e multifuncional,
                  ideal para relaxar, se divertir e criar memórias que
                  transcendem o tempo.
                </p>
              </div>

              <div className="col-lg-5 p-80 align-content-center">
                <h3 className="lh-1 js-splittext-lines ">
                  <span className="fsz-35 color-gray font-palast-regular">
                    Lazer e diversão
                  </span>
                  <strong className="fsz-40 color-brown2 font-palast-bold-italic">
                    {" "}
                    para todos os gostos.
                  </strong>
                </h3>

                <div className="d-flex mt-30 ms-20 fsz-16 ltspc-2 list-itens">
                  <ul className="col-lg-6 color-gray wow zoomIn slow ">
                    {firstGroup.map((item, index) => (
                      <li
                        style={{ listStyleType: "disc" }}
                        key={`group1-${index}`}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>

                  <ul className="col-lg-6 color-gray wow zoomIn slow ">
                    {secondGroup.map((item, index) => (
                      <li
                        style={{ listStyleType: "disc" }}
                        key={`group2-${index}`}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  onClick={() => window.openModal()}
                  className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 bg-white mt-20 wow zoomIn slow"
                >
                  <span className="ltspc-1"> Quero saber mais </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tc-slider-style" style={{ position: "relative" }}>
        <ImgSlider slides={socialAreasSocialClub} />
      </section>

      <Plan
        id={'plan-social-club'}
        title={"Plantas"}
        subTitle={"Social Club"}
        slides={plansSocialClub}
        bgColor={"plan-bg-light-gay"}
      />
    </>
  );
}

export default SocialClub;
